import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {
  [key: string]: unknown;
}> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends {
  [key: string]: unknown;
}, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  BigInt: {
    input: any;
    output: any;
  };
  DateTime: {
    input: any;
    output: any;
  };
};

/** Availability */
export type Availability = {
  __typename?: "Availability";
  available?: Maybe<Scalars["Boolean"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  dayOfWeek: Array<WeekDays>;
  endTime: Scalars["DateTime"]["output"];
  id: Scalars["BigInt"]["output"];
  schedule: Schedule;
  scheduleId: Scalars["BigInt"]["output"];
  startTime: Scalars["DateTime"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

/** Availability Connection */
export type AvailabilityConnection = {
  __typename?: "AvailabilityConnection";
  edges: Array<AvailabilityEdge>;
  nodes: Array<Availability>;
  pageInfo: OffsetPageInfo;
};
export type AvailabilityCreateInput = {
  available?: InputMaybe<Scalars["Boolean"]["input"]>;
  dayOfWeek: Array<WeekDays>;
  endTime: Scalars["DateTime"]["input"];
  scheduleId: Scalars["BigInt"]["input"];
  startTime: Scalars["DateTime"]["input"];
};

/** Availability Edge */
export type AvailabilityEdge = {
  __typename?: "AvailabilityEdge";
  cursor: Scalars["String"]["output"];
  node: Availability;
};

/** Availability Exception */
export type AvailabilityException = {
  __typename?: "AvailabilityException";
  available?: Maybe<Scalars["Boolean"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  dayOfWeek?: Maybe<Array<WeekDays>>;
  endTime: Scalars["DateTime"]["output"];
  id: Scalars["BigInt"]["output"];
  schedule: Schedule;
  scheduleId: Scalars["BigInt"]["output"];
  startTime: Scalars["DateTime"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  validFrom: Scalars["DateTime"]["output"];
  validUntil: Scalars["DateTime"]["output"];
};

/** Availability Exception Connection */
export type AvailabilityExceptionConnection = {
  __typename?: "AvailabilityExceptionConnection";
  edges: Array<AvailabilityExceptionEdge>;
  nodes: Array<AvailabilityException>;
  pageInfo: OffsetPageInfo;
};
export type AvailabilityExceptionCreateInput = {
  available?: InputMaybe<Scalars["Boolean"]["input"]>;
  dayOfWeek?: InputMaybe<Array<WeekDays>>;
  endTime: Scalars["DateTime"]["input"];
  scheduleId: Scalars["BigInt"]["input"];
  startTime: Scalars["DateTime"]["input"];
  validFrom: Scalars["DateTime"]["input"];
  validUntil: Scalars["DateTime"]["input"];
};

/** Availability Exception Edge */
export type AvailabilityExceptionEdge = {
  __typename?: "AvailabilityExceptionEdge";
  cursor: Scalars["String"]["output"];
  node: AvailabilityException;
};
export type AvailabilityExceptionListRelationFilter = {
  every?: InputMaybe<AvailabilityExceptionWhereInput>;
  none?: InputMaybe<AvailabilityExceptionWhereInput>;
  some?: InputMaybe<AvailabilityExceptionWhereInput>;
};
export type AvailabilityExceptionOrderByInput = {
  available?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  schedule?: InputMaybe<ScheduleOrderByInput>;
  scheduleId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  validFrom?: InputMaybe<SortOrder>;
  validUntil?: InputMaybe<SortOrder>;
};
export type AvailabilityExceptionUpdateInput = {
  available?: InputMaybe<Scalars["Boolean"]["input"]>;
  dayOfWeek?: InputMaybe<Array<WeekDays>>;
  endTime?: InputMaybe<Scalars["DateTime"]["input"]>;
  scheduleId?: InputMaybe<Scalars["BigInt"]["input"]>;
  startTime?: InputMaybe<Scalars["DateTime"]["input"]>;
  validFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  validUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
};
export type AvailabilityExceptionWhereInput = {
  AND?: InputMaybe<Array<AvailabilityExceptionWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityExceptionWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityExceptionWhereInput>>;
  available?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<NumberFilter>;
  endTime?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  schedule?: InputMaybe<ScheduleWhereInput>;
  scheduleId?: InputMaybe<BigIntFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
  validFrom?: InputMaybe<DateTimeFilter>;
  validUntil?: InputMaybe<DateTimeFilter>;
};
export type AvailabilityListRelationFilter = {
  every?: InputMaybe<AvailabilityWhereInput>;
  none?: InputMaybe<AvailabilityWhereInput>;
  some?: InputMaybe<AvailabilityWhereInput>;
};
export type AvailabilityOrderByInput = {
  available?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  schedule?: InputMaybe<ScheduleOrderByInput>;
  scheduleId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
};
export type AvailabilityUpdateInput = {
  available?: InputMaybe<Scalars["Boolean"]["input"]>;
  dayOfWeek?: InputMaybe<Array<WeekDays>>;
  endTime?: InputMaybe<Scalars["DateTime"]["input"]>;
  scheduleId?: InputMaybe<Scalars["BigInt"]["input"]>;
  startTime?: InputMaybe<Scalars["DateTime"]["input"]>;
};
export type AvailabilityWhereInput = {
  AND?: InputMaybe<Array<AvailabilityWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityWhereInput>>;
  available?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<NumberFilter>;
  endTime?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  schedule?: InputMaybe<ScheduleWhereInput>;
  scheduleId?: InputMaybe<BigIntFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
};

/** Available Slots */
export type AvailableSlot = {
  __typename?: "AvailableSlot";
  date?: Maybe<Scalars["DateTime"]["output"]>;
  slots?: Maybe<Array<Slot>>;
};
export type BigIntFilter = {
  equals?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};
export type BoolFilter = {
  equals?: InputMaybe<Scalars["Boolean"]["input"]>;
  not?: InputMaybe<NestedBoolFilter>;
};

/** Customer */
export type Customer = {
  __typename?: "Customer";
  address?: Maybe<Scalars["String"]["output"]>;
  company?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["BigInt"]["output"];
  name: Scalars["String"]["output"];
  phone: Scalars["String"]["output"];
  shopifyId?: Maybe<Scalars["String"]["output"]>;
  source: CustomerSource;
  trialRequests: Array<TrialRequest>;
  updatedAt: Scalars["DateTime"]["output"];
  utm?: Maybe<Scalars["String"]["output"]>;
};

/** Customer Connection */
export type CustomerConnection = {
  __typename?: "CustomerConnection";
  edges: Array<CustomerEdge>;
  nodes: Array<Customer>;
  pageInfo: OffsetPageInfo;
};
export type CustomerCreateInput = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  company?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  source: CustomerSource;
  utm?: InputMaybe<Scalars["String"]["input"]>;
};

/** Customer Edge */
export type CustomerEdge = {
  __typename?: "CustomerEdge";
  cursor: Scalars["String"]["output"];
  node: Customer;
};
export type CustomerOrderByInput = {
  address?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
};
export enum CustomerSource {
  CarpetCentre = "CARPET_CENTRE",
  KnotHome = "KNOT_HOME",
  KnotStudio = "KNOT_STUDIO",
}
export type CustomerUpdateInput = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  company?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<CustomerSource>;
  utm?: InputMaybe<Scalars["String"]["input"]>;
};
export type CustomerWhereInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  address?: InputMaybe<StringFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  utm?: InputMaybe<StringFilter>;
};
export type DateTimeFilter = {
  equals?: InputMaybe<Scalars["DateTime"]["input"]>;
  gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  in?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
  lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

/** Excel Report */
export type ExcelReport = {
  __typename?: "ExcelReport";
  folderPath: Scalars["String"]["output"];
};
export type Mutation = {
  __typename?: "Mutation";
  createAvailability: Availability;
  createAvailabilityException: AvailabilityException;
  createSchedule: Schedule;
  createTrialRequest: TrialRequest;
  deleteTrialRequest: TrialRequest;
  updateAvailability: Availability;
  updateAvailabilityException: AvailabilityException;
  updateSchedule: Schedule;
  updateTrialRequest: TrialRequest;
};
export type MutationCreateAvailabilityArgs = {
  data: AvailabilityCreateInput;
};
export type MutationCreateAvailabilityExceptionArgs = {
  data: AvailabilityExceptionCreateInput;
};
export type MutationCreateScheduleArgs = {
  data: ScheduleCreateInput;
};
export type MutationCreateTrialRequestArgs = {
  data: TrialRequestCreateInput;
};
export type MutationDeleteTrialRequestArgs = {
  id: Scalars["ID"]["input"];
};
export type MutationUpdateAvailabilityArgs = {
  id: Scalars["ID"]["input"];
  updates: AvailabilityUpdateInput;
};
export type MutationUpdateAvailabilityExceptionArgs = {
  id: Scalars["ID"]["input"];
  updates: AvailabilityExceptionUpdateInput;
};
export type MutationUpdateScheduleArgs = {
  id: Scalars["ID"]["input"];
  updates: ScheduleUpdateInput;
};
export type MutationUpdateTrialRequestArgs = {
  id: Scalars["ID"]["input"];
  updates: TrialRequestUpdateInput;
};
export type NestedBigIntFilter = {
  equals?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};
export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars["Boolean"]["input"]>;
  not?: InputMaybe<NestedBoolFilter>;
};
export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars["DateTime"]["input"]>;
  gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  in?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
  lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};
export type NestedNumberFilter = {
  equals?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  not?: InputMaybe<NestedNumberFilter>;
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};
export type NestedStringFilter = {
  contains?: InputMaybe<Scalars["String"]["input"]>;
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  equals?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
};
export type NumberFilter = {
  equals?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  not?: InputMaybe<NestedNumberFilter>;
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Offset Pagination */
export type OffsetPageInfo = {
  __typename?: "OffsetPageInfo";
  currentPage: Scalars["Float"]["output"];
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  pageCount: Scalars["Float"]["output"];
  pageSize: Scalars["Float"]["output"];
  totalCount: Scalars["Float"]["output"];
};

/** Product Details */
export type ProductDetails = {
  __typename?: "ProductDetails";
  featuredImageUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  price?: Maybe<Scalars["String"]["output"]>;
  productHandle?: Maybe<Scalars["String"]["output"]>;
  productName: Scalars["String"]["output"];
  sku: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};
export type Query = {
  __typename?: "Query";
  availabilities: AvailabilityConnection;
  availability?: Maybe<Availability>;
  availabilityException?: Maybe<AvailabilityException>;
  availabilityExceptions: AvailabilityExceptionConnection;
  availableSlotsForSchedule: Array<AvailableSlot>;
  customer?: Maybe<Customer>;
  customers: CustomerConnection;
  /** This query is used to export the list to Excel */
  exportTrialRequestsToExcel: ExcelReport;
  schedule?: Maybe<Schedule>;
  schedules: ScheduleConnection;
  trialRequest?: Maybe<TrialRequest>;
  trialRequests: TrialRequestConnection;
};
export type QueryAvailabilitiesArgs = {
  orderBy?: InputMaybe<Array<AvailabilityOrderByInput>>;
  page?: InputMaybe<Scalars["Float"]["input"]>;
  pageSize?: InputMaybe<Scalars["Float"]["input"]>;
  where?: InputMaybe<AvailabilityWhereInput>;
};
export type QueryAvailabilityArgs = {
  id: Scalars["BigInt"]["input"];
};
export type QueryAvailabilityExceptionArgs = {
  id: Scalars["BigInt"]["input"];
};
export type QueryAvailabilityExceptionsArgs = {
  orderBy?: InputMaybe<Array<AvailabilityExceptionOrderByInput>>;
  page?: InputMaybe<Scalars["Float"]["input"]>;
  pageSize?: InputMaybe<Scalars["Float"]["input"]>;
  where?: InputMaybe<AvailabilityExceptionWhereInput>;
};
export type QueryAvailableSlotsForScheduleArgs = {
  endDate: Scalars["DateTime"]["input"];
  scheduleSlug: Scalars["String"]["input"];
  startDate: Scalars["DateTime"]["input"];
};
export type QueryCustomerArgs = {
  id: Scalars["BigInt"]["input"];
};
export type QueryCustomersArgs = {
  orderBy?: InputMaybe<Array<CustomerOrderByInput>>;
  page?: InputMaybe<Scalars["Float"]["input"]>;
  pageSize?: InputMaybe<Scalars["Float"]["input"]>;
  where?: InputMaybe<CustomerWhereInput>;
};
export type QueryExportTrialRequestsToExcelArgs = {
  orderBy?: InputMaybe<Array<TrialRequestOrderByInput>>;
  page?: InputMaybe<Scalars["Float"]["input"]>;
  pageSize?: InputMaybe<Scalars["Float"]["input"]>;
  where?: InputMaybe<TrialRequestWhereInput>;
};
export type QueryScheduleArgs = {
  id: Scalars["BigInt"]["input"];
};
export type QuerySchedulesArgs = {
  orderBy?: InputMaybe<Array<ScheduleOrderByInput>>;
  page?: InputMaybe<Scalars["Float"]["input"]>;
  pageSize?: InputMaybe<Scalars["Float"]["input"]>;
  where?: InputMaybe<ScheduleWhereInput>;
};
export type QueryTrialRequestArgs = {
  id: Scalars["BigInt"]["input"];
};
export type QueryTrialRequestsArgs = {
  orderBy?: InputMaybe<Array<TrialRequestOrderByInput>>;
  page?: InputMaybe<Scalars["Float"]["input"]>;
  pageSize?: InputMaybe<Scalars["Float"]["input"]>;
  where?: InputMaybe<TrialRequestWhereInput>;
};

/** Schedule */
export type Schedule = {
  __typename?: "Schedule";
  active?: Maybe<Scalars["Boolean"]["output"]>;
  availabilities?: Maybe<Array<Availability>>;
  availabilityExceptions?: Maybe<Array<AvailabilityException>>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["BigInt"]["output"];
  name: Scalars["String"]["output"];
  slotCapacity?: Maybe<Scalars["Float"]["output"]>;
  slotDuration: Scalars["Float"]["output"];
  slug: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

/** Schedule Connection */
export type ScheduleConnection = {
  __typename?: "ScheduleConnection";
  edges: Array<ScheduleEdge>;
  nodes: Array<Schedule>;
  pageInfo: OffsetPageInfo;
};
export type ScheduleCreateInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  slotCapacity?: InputMaybe<Scalars["Float"]["input"]>;
  slotDuration: Scalars["Float"]["input"];
  slug: Scalars["String"]["input"];
};

/** Schedule Edge */
export type ScheduleEdge = {
  __typename?: "ScheduleEdge";
  cursor: Scalars["String"]["output"];
  node: Schedule;
};
export type ScheduleOrderByInput = {
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  slotCapacity?: InputMaybe<SortOrder>;
  slotDuration?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
};
export type ScheduleUpdateInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  slotCapacity?: InputMaybe<Scalars["Float"]["input"]>;
  slotDuration?: InputMaybe<Scalars["Float"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
};
export type ScheduleWhereInput = {
  AND?: InputMaybe<Array<ScheduleWhereInput>>;
  NOT?: InputMaybe<Array<ScheduleWhereInput>>;
  OR?: InputMaybe<Array<ScheduleWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  availabilities?: InputMaybe<AvailabilityListRelationFilter>;
  availabilityExceptions?: InputMaybe<AvailabilityExceptionListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringFilter>;
  slotCapacity?: InputMaybe<NumberFilter>;
  slotDuration?: InputMaybe<NumberFilter>;
  slug?: InputMaybe<StringFilter>;
};

/** Slot */
export type Slot = {
  __typename?: "Slot";
  endTime?: Maybe<Scalars["String"]["output"]>;
  startTime?: Maybe<Scalars["String"]["output"]>;
};

/** Sort Order */
export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}
export type StringFilter = {
  contains?: InputMaybe<Scalars["String"]["input"]>;
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  equals?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
};

/** Trial Request */
export type TrialRequest = {
  __typename?: "TrialRequest";
  createdAt: Scalars["DateTime"]["output"];
  customer: Customer;
  customerId: Scalars["BigInt"]["output"];
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  duration?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["BigInt"]["output"];
  productDetails?: Maybe<Array<ProductDetails>>;
  products?: Maybe<Array<Scalars["String"]["output"]>>;
  region?: Maybe<Scalars["String"]["output"]>;
  source: TrialRequestSource;
  startDateTime?: Maybe<Scalars["DateTime"]["output"]>;
  status?: Maybe<TrialRequestStatus>;
  updatedAt: Scalars["DateTime"]["output"];
  utm?: Maybe<Scalars["String"]["output"]>;
};

/** Trial Request Connection */
export type TrialRequestConnection = {
  __typename?: "TrialRequestConnection";
  edges: Array<TrialRequestEdge>;
  nodes: Array<TrialRequest>;
  pageInfo: OffsetPageInfo;
};
export type TrialRequestCreateInput = {
  customer: CustomerCreateInput;
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  products?: InputMaybe<Array<Scalars["String"]["input"]>>;
  region?: InputMaybe<Scalars["String"]["input"]>;
  source: TrialRequestSource;
  startDateTime?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<TrialRequestStatus>;
  utm?: InputMaybe<Scalars["String"]["input"]>;
};

/** Trial Request Edge */
export type TrialRequestEdge = {
  __typename?: "TrialRequestEdge";
  cursor: Scalars["String"]["output"];
  node: TrialRequest;
};
export type TrialRequestOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByInput>;
  customerId?: InputMaybe<SortOrder>;
  deleted?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};
export enum TrialRequestSource {
  CarpetCentre = "CARPET_CENTRE",
  KnotHome = "KNOT_HOME",
}
export enum TrialRequestStatus {
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Confirmed = "CONFIRMED",
  OnHold = "ON_HOLD",
  Pending = "PENDING",
}
export type TrialRequestUpdateInput = {
  customer?: InputMaybe<CustomerUpdateInput>;
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  products?: InputMaybe<Array<Scalars["String"]["input"]>>;
  region?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<TrialRequestSource>;
  startDateTime?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<TrialRequestStatus>;
  utm?: InputMaybe<Scalars["String"]["input"]>;
};
export type TrialRequestWhereInput = {
  AND?: InputMaybe<Array<TrialRequestWhereInput>>;
  NOT?: InputMaybe<Array<TrialRequestWhereInput>>;
  OR?: InputMaybe<Array<TrialRequestWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerWhereInput>;
  customerId?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BoolFilter>;
  duration?: InputMaybe<NumberFilter>;
  id?: InputMaybe<BigIntFilter>;
  region?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  startDateTime?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringFilter>;
  utm?: InputMaybe<StringFilter>;
};
export enum WeekDays {
  Friday = "FRIDAY",
  Monday = "MONDAY",
  Saturday = "SATURDAY",
  Sunday = "SUNDAY",
  Thursday = "THURSDAY",
  Tuesday = "TUESDAY",
  Wednesday = "WEDNESDAY",
}
export type GetAvailableSlotsQueryVariables = Exact<{
  startDate: Scalars["DateTime"]["input"];
  scheduleSlug: Scalars["String"]["input"];
  endDate: Scalars["DateTime"]["input"];
}>;
export type GetAvailableSlotsQuery = {
  __typename?: "Query";
  availableSlotsForSchedule: Array<{
    __typename?: "AvailableSlot";
    date?: any | null;
    slots?: Array<{
      __typename?: "Slot";
      startTime?: string | null;
      endTime?: string | null;
    }> | null;
  }>;
};
export type TrialRequestDetailsFragment = {
  __typename?: "TrialRequest";
  id: any;
  region?: string | null;
  startDateTime?: any | null;
  duration?: number | null;
  source: TrialRequestSource;
  status?: TrialRequestStatus | null;
  products?: Array<string> | null;
  customer: {
    __typename?: "Customer";
    id: any;
    name: string;
    phone: string;
    email?: string | null;
    address?: string | null;
  };
};
export type GetTrialRequestQueryVariables = Exact<{
  id: Scalars["BigInt"]["input"];
}>;
export type GetTrialRequestQuery = {
  __typename?: "Query";
  trialRequest?: {
    __typename?: "TrialRequest";
    id: any;
    region?: string | null;
    startDateTime?: any | null;
    duration?: number | null;
    source: TrialRequestSource;
    status?: TrialRequestStatus | null;
    products?: Array<string> | null;
    customer: {
      __typename?: "Customer";
      id: any;
      name: string;
      phone: string;
      email?: string | null;
      address?: string | null;
    };
  } | null;
};
export type CreateTrialRequestMutationVariables = Exact<{
  data: TrialRequestCreateInput;
}>;
export type CreateTrialRequestMutation = {
  __typename?: "Mutation";
  createTrialRequest: {
    __typename?: "TrialRequest";
    id: any;
    region?: string | null;
    startDateTime?: any | null;
    duration?: number | null;
    source: TrialRequestSource;
    status?: TrialRequestStatus | null;
    products?: Array<string> | null;
    customer: {
      __typename?: "Customer";
      id: any;
      name: string;
      phone: string;
      email?: string | null;
      address?: string | null;
    };
  };
};
export type UpdateTrialRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  updates: TrialRequestUpdateInput;
}>;
export type UpdateTrialRequestMutation = {
  __typename?: "Mutation";
  updateTrialRequest: {
    __typename?: "TrialRequest";
    id: any;
  };
};
export const TrialRequestDetailsFragmentDoc = gql`
  fragment TrialRequestDetails on TrialRequest {
    id
    customer {
      id
      name
      phone
      email
      address
    }
    region
    startDateTime
    duration
    source
    status
    products
  }
`;
export const GetAvailableSlotsDocument = gql`
  query GetAvailableSlots(
    $startDate: DateTime!
    $scheduleSlug: String!
    $endDate: DateTime!
  ) {
    availableSlotsForSchedule(
      startDate: $startDate
      scheduleSlug: $scheduleSlug
      endDate: $endDate
    ) {
      date
      slots {
        startTime
        endTime
      }
    }
  }
`;

/**
 * __useGetAvailableSlotsQuery__
 *
 * To run a query within a React component, call `useGetAvailableSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableSlotsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      scheduleSlug: // value for 'scheduleSlug'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetAvailableSlotsQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableSlotsQuery, GetAvailableSlotsQueryVariables> & ({
  variables: GetAvailableSlotsQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetAvailableSlotsQuery, GetAvailableSlotsQueryVariables>(GetAvailableSlotsDocument, options);
}
export function useGetAvailableSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableSlotsQuery, GetAvailableSlotsQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetAvailableSlotsQuery, GetAvailableSlotsQueryVariables>(GetAvailableSlotsDocument, options);
}
export function useGetAvailableSlotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableSlotsQuery, GetAvailableSlotsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetAvailableSlotsQuery, GetAvailableSlotsQueryVariables>(GetAvailableSlotsDocument, options);
}
export type GetAvailableSlotsQueryHookResult = ReturnType<typeof useGetAvailableSlotsQuery>;
export type GetAvailableSlotsLazyQueryHookResult = ReturnType<typeof useGetAvailableSlotsLazyQuery>;
export type GetAvailableSlotsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableSlotsSuspenseQuery>;
export type GetAvailableSlotsQueryResult = Apollo.QueryResult<GetAvailableSlotsQuery, GetAvailableSlotsQueryVariables>;
export const GetTrialRequestDocument = gql`
  query GetTrialRequest($id: BigInt!) {
    trialRequest(id: $id) {
      ...TrialRequestDetails
    }
  }
  ${TrialRequestDetailsFragmentDoc}
`;

/**
 * __useGetTrialRequestQuery__
 *
 * To run a query within a React component, call `useGetTrialRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrialRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrialRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTrialRequestQuery(baseOptions: Apollo.QueryHookOptions<GetTrialRequestQuery, GetTrialRequestQueryVariables> & ({
  variables: GetTrialRequestQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetTrialRequestQuery, GetTrialRequestQueryVariables>(GetTrialRequestDocument, options);
}
export function useGetTrialRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrialRequestQuery, GetTrialRequestQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetTrialRequestQuery, GetTrialRequestQueryVariables>(GetTrialRequestDocument, options);
}
export function useGetTrialRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrialRequestQuery, GetTrialRequestQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetTrialRequestQuery, GetTrialRequestQueryVariables>(GetTrialRequestDocument, options);
}
export type GetTrialRequestQueryHookResult = ReturnType<typeof useGetTrialRequestQuery>;
export type GetTrialRequestLazyQueryHookResult = ReturnType<typeof useGetTrialRequestLazyQuery>;
export type GetTrialRequestSuspenseQueryHookResult = ReturnType<typeof useGetTrialRequestSuspenseQuery>;
export type GetTrialRequestQueryResult = Apollo.QueryResult<GetTrialRequestQuery, GetTrialRequestQueryVariables>;
export const CreateTrialRequestDocument = gql`
  mutation CreateTrialRequest($data: TrialRequestCreateInput!) {
    createTrialRequest(data: $data) {
      ...TrialRequestDetails
    }
  }
  ${TrialRequestDetailsFragmentDoc}
`;
export type CreateTrialRequestMutationFn = Apollo.MutationFunction<CreateTrialRequestMutation, CreateTrialRequestMutationVariables>;

/**
 * __useCreateTrialRequestMutation__
 *
 * To run a mutation, you first call `useCreateTrialRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrialRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrialRequestMutation, { data, loading, error }] = useCreateTrialRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTrialRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrialRequestMutation, CreateTrialRequestMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<CreateTrialRequestMutation, CreateTrialRequestMutationVariables>(CreateTrialRequestDocument, options);
}
export type CreateTrialRequestMutationHookResult = ReturnType<typeof useCreateTrialRequestMutation>;
export type CreateTrialRequestMutationResult = Apollo.MutationResult<CreateTrialRequestMutation>;
export type CreateTrialRequestMutationOptions = Apollo.BaseMutationOptions<CreateTrialRequestMutation, CreateTrialRequestMutationVariables>;
export const UpdateTrialRequestDocument = gql`
  mutation UpdateTrialRequest($id: ID!, $updates: TrialRequestUpdateInput!) {
    updateTrialRequest(id: $id, updates: $updates) {
      id
    }
  }
`;
export type UpdateTrialRequestMutationFn = Apollo.MutationFunction<UpdateTrialRequestMutation, UpdateTrialRequestMutationVariables>;

/**
 * __useUpdateTrialRequestMutation__
 *
 * To run a mutation, you first call `useUpdateTrialRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrialRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrialRequestMutation, { data, loading, error }] = useUpdateTrialRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateTrialRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrialRequestMutation, UpdateTrialRequestMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<UpdateTrialRequestMutation, UpdateTrialRequestMutationVariables>(UpdateTrialRequestDocument, options);
}
export type UpdateTrialRequestMutationHookResult = ReturnType<typeof useUpdateTrialRequestMutation>;
export type UpdateTrialRequestMutationResult = Apollo.MutationResult<UpdateTrialRequestMutation>;
export type UpdateTrialRequestMutationOptions = Apollo.BaseMutationOptions<UpdateTrialRequestMutation, UpdateTrialRequestMutationVariables>;